import { useEffect, useMemo, useRef, useState } from "react";
import { useInView } from "framer-motion";

function clamp(n, min, max) {
  return Math.min(max, Math.max(min, n));
}

export function MetricCounter({ value, suffix, durationMs = 900 }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-120px" });
  const [display, setDisplay] = useState(0);

  const target = useMemo(() => Math.max(0, value), [value]);

  useEffect(() => {
    if (!inView) return;

    let raf = 0;
    const start = performance.now();

    const tick = (now) => {
      const t = clamp((now - start) / durationMs, 0, 1);
      const eased = 1 - Math.pow(1 - t, 3);
      setDisplay(Math.round(target * eased));
      if (t < 1) raf = requestAnimationFrame(tick);
    };

    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [durationMs, inView, target]);

  return (
    <div ref={ref} className="font-[var(--font-mono)] tracking-tight">
      {display}
      {suffix}
    </div>
  );
}
